import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppState } from "../context/AppContext";
import { Controller, useForm } from "react-hook-form";
import { auth } from "../services/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";

function SignIn() {
  const { state } = useAppState();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { email: "", password: "" } });

  useEffect(() => {
    if (!state.authChecked) return;
    if (!state.user) return setLoading(false);
    if (!state.user.practices || !state.user.practices.length) {
      return alert(
        "No practices associated with this account, please reach out to support@evviaftercare.com"
      );
    }
    navigate(`/${state.user.practices[0].slug}`);
  }, [state, navigate]);

  function onSubmit(data) {
    setErrorMessage(null);
    setLoading(true);

    signInWithEmailAndPassword(auth, data.email, data.password).catch(
      (error) => {
        if (
          error.code === "auth/user-not-found" ||
          error.code === "auth/wrong-password"
        ) {
          setErrorMessage("Invalid email or password");
        } else {
          setErrorMessage(error.message);
        }
        // hide loading if there's an error
        setLoading(false);
      }
    );
  }

  if (loading) {
    return <div className="loading-screen regular-2xl">Loading...</div>;
  }

  return (
    <div className="container">
      <h2 className="mb-2 text-center">Sign In</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="fieldgroup">
          <fieldset>
            <label>Email</label>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "This field is required",
              }}
              render={({ field }) => (
                <input type="email" data-cy="email-input" {...field} />
              )}
            />
            <span className="input-error">{errors["email"]?.message}</span>
          </fieldset>

          <fieldset>
            <label>Password</label>
            <Controller
              name="password"
              control={control}
              rules={{
                required: "This field is required",
              }}
              render={({ field }) => (
                <input type="password" data-cy="password-input" {...field} />
              )}
            />
            <span className="input-error">{errors["password"]?.message}</span>
            <div>
              <Link to="/password-reset">Forgot password?</Link>
            </div>
          </fieldset>
        </div>

        {errorMessage && (
          <div className="input-error" data-cy="error-message">
            {errorMessage}
          </div>
        )}

        <div className="mt-2 text-center">
          <button className="button" type="submit" data-cy="login-button">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default SignIn;
